import React from 'react';
import './dynamicCards.css';

import { I18n } from 'react-redux-i18n';
import moment from 'moment';

import TruckLoadChartCanvas from '../truckLoadChartCanvas/truckLoadChartCanvas';

function processDailyLoadData(dailyLoadData) {
  let totalPendAloc = 0;
  let totalPendSep = 0;
  let totalPendConf = 0;
  let totalPendBill = 0;
  let totalPendDock = 0;
  let totalPendingCount = 0;
  let totalDoneCount = 0;

  const result = dailyLoadData
    .map((dailyLoad) => dailyLoad.dailyLoadCarrier.map((carrierData) => {
      const { greenLightValue, yellowLightValue } = carrierData.carrier[0];

      let pendingCount = 0;
      let doneCount = 0;
      let pendAloc = 0;
      let pendSep = 0;
      let pendConf = 0;
      let pendBill = 0;
      let pendDock = 0;

      const now = moment();

      const cutOffTime = moment(dailyLoad.cutOffTime, 'HH:mm:ss');

      const greenLightTime = cutOffTime.clone().subtract(greenLightValue, 'minutes');
      const yellowLightTime = cutOffTime.clone().subtract(yellowLightValue, 'minutes');

      const isRedLight = now.isAfter(cutOffTime);
      const isGreenLight = now.isBefore(cutOffTime, greenLightTime);
      const isYellowLight = now.isBefore(cutOffTime, yellowLightTime);

      let backgroundTitleColor = 'transparent';

      if (isRedLight) {
        backgroundTitleColor = 'red';
      } else if (isGreenLight) {
        backgroundTitleColor = 'green';
      } else if (isYellowLight) {
        backgroundTitleColor = 'yellow';
      }

      (carrierData.carrier[0].outboundOrder || []).forEach((order) => {
        if (order.status !== 10) {
          switch (order.status) {
            case 1:
              pendAloc += 1;
              totalPendAloc += 1;
              break;
            case 3:
              pendSep += 1;
              totalPendSep += 1;
              break;
            case 5:
              pendConf += 1;
              totalPendConf += 1;
              break;
            case 9:
              pendBill += 1;
              totalPendBill += 1;
              break;
            case 6:
              pendDock += 1;
              totalPendDock += 1;
              break;
            default: return '';
          }
          pendingCount += 1;
          totalPendingCount += 1;
        } else {
          doneCount += 1;
          totalDoneCount += 1;
        }
      });

      return {
        businessName: carrierData.carrier[0].businessName,
        outboundOrders: carrierData.carrier[0].outboundOrder || [],
        cutOffTime: dailyLoad.cutOffTime,
        pending: pendingCount,
        done: doneCount,
        pendAloc,
        pendSep,
        pendConf,
        pendBill,
        pendDock,
        percAloc: pendAloc ? (pendAloc / (pendingCount + doneCount)) * 100 : 0,
        percSep: pendSep ? (pendSep / (pendingCount + doneCount)) * 100 : 0,
        percConf: pendConf ? (pendConf / (pendingCount + doneCount)) * 100 : 0,
        percBill: pendBill ? (pendBill / (pendingCount + doneCount)) * 100 : 0,
        percDock: pendDock ? (pendDock / (pendingCount + doneCount)) * 100 : 0,
        totalPendAloc,
        totalPendSep,
        totalPendConf,
        totalPendBill,
        totalPendDock,
        totalPending: totalPendingCount,
        totalDone: totalDoneCount,
        totalPercAloc: totalPendAloc ? (totalPendAloc / (totalPendingCount + totalDoneCount)) * 100 : 0,
        totalPercSep: totalPendSep ? (totalPendSep / (totalPendingCount + totalDoneCount)) * 100 : 0,
        totalPercConf: totalPendConf ? (totalPendConf / (totalPendingCount + totalDoneCount)) * 100 : 0,
        totalPercBill: totalPendBill ? (totalPendBill / (totalPendingCount + totalDoneCount)) * 100 : 0,
        totalPercDock: totalPendDock ? (totalPendDock / (totalPendingCount + totalDoneCount)) * 100 : 0,
        backgroundTitleColor,
      };
    }))
    .reduce((acc, curr) => acc.concat(curr), []);

  return result.sort((a, b) => new Date(a.cutOffTime) - new Date(b.cutOffTime));
}

function formatCutOffTime(cutOffTime) {
  return moment(cutOffTime, 'HH:mm:ss').format('HH:mm');
}

function DynamicCards({ data }) {
  const dataList = processDailyLoadData(data);

  if (dataList.length === 0) {
    return (
      <p>{I18n.t('BEE4187' /* Nenhum registro disponível. */)}</p>
    );
  }

  return (
    <div className="cards-container">
      {/* Card de informações gerais */}
      <div key="general-key" className="dynamic-card">
        <h1 style={{
          padding: '5px',
          borderRadius: '15px',
          fontSize: '50px',
        }}
        >
          {I18n.t('BEE191' /* Geral */).toUpperCase()}
        </h1>
        <h4>{`${dataList[dataList.length - 1].totalPending} ${I18n.t('BEE4179' /* Docs em processamento */)}`}</h4>
        <div className="status-bars">
          <div key="general-aloc" className="status-bar">
            <span className="status-label">{I18n.t('BEE4181' /* Pend. Alocação */)}</span>
            <div className="bar-container">
              <div
                className="bar"
                style={{
                  width: `${dataList[dataList.length - 1].totalPercAloc}%`,
                  backgroundColor: '#FF0000',
                }}
              />
              <span className="pending-count">{dataList[dataList.length - 1].totalPendAloc}</span>
            </div>
          </div>
          <div key="general-sep" className="status-bar">
            <span className="status-label">{I18n.t('BEE4182' /* Pend. Separação */)}</span>
            <div className="bar-container">
              <div
                className="bar"
                style={{
                  width: `${dataList[dataList.length - 1].totalPercSep}%`,
                  backgroundColor: '#FFA500',
                }}
              />
              <span className="pending-count">{dataList[dataList.length - 1].totalPendSep}</span>
            </div>
          </div>
          <div key="general-conf" className="status-bar">
            <span className="status-label">{I18n.t('BEE4183' /* Pend. Conferência */)}</span>
            <div className="bar-container">
              <div
                className="bar"
                style={{
                  width: `${dataList[dataList.length - 1].totalPercConf}%`,
                  backgroundColor: '#008000',
                }}
              />
              <span className="pending-count">{dataList[dataList.length - 1].totalPendConf}</span>
            </div>
          </div>
          <div key="general-fat" className="status-bar">
            <span className="status-label">{I18n.t('BEE4184' /* Pend. Faturamento */)}</span>
            <div className="bar-container">
              <div
                className="bar"
                style={{
                  width: `${dataList[dataList.length - 1].totalPercBill}%`,
                  backgroundColor: '#0000FF',
                }}
              />
              <span className="pending-count">{dataList[dataList.length - 1].totalPendBill}</span>
            </div>
          </div>
          <div key="general-dock" className="status-bar">
            <span className="status-label">{I18n.t('BEE4185' /* Pend. Docas */)}</span>
            <div className="bar-container">
              <div
                className="bar"
                style={{
                  width: `${dataList[dataList.length - 1].totalPercDock}%`,
                  backgroundColor: '#FFFF00',
                }}
              />
              <span className="pending-count">{dataList[dataList.length - 1].totalPendDock}</span>
            </div>
          </div>
          <TruckLoadChartCanvas
            finishedQty={dataList[dataList.length - 1].totalDone}
            pendingQty={dataList[dataList.length - 1].totalPending}
            isGeneral
          />
        </div>
      </div>
      {/* Card de informações dinâmicas */}
      {dataList.map((info, index) => (
        <div key={`cards-${index}`} className="dynamic-card">
          <h2 style={{
            backgroundColor: info.backgroundTitleColor,
            color: 'white',
            padding: '5px',
            borderRadius: '15px',
          }}
          >
            {info.businessName}
          </h2>
          <h3>
            {`${I18n.t('BEE4178' /* Horário */)}: ${formatCutOffTime(info.cutOffTime)}`}
          </h3>
          <h4>{`${info.pending} ${I18n.t('BEE4179' /* Docs em processamento */)}`}</h4>
          <div className="status-bars">
            <div key={`aloc-${index}`} className="status-bar">
              <span className="status-label">{I18n.t('BEE4181' /* Pend. Alocação */)}</span>
              <div className="bar-container">
                <div
                  className="bar"
                  style={{
                    width: `${info.percAloc}%`,
                    backgroundColor: '#FF0000',
                  }}
                />
                <span className="pending-count">{info.pendAloc}</span>
              </div>
            </div>
            <div key={`sep-${index}`} className="status-bar">
              <span className="status-label">{I18n.t('BEE4182' /* Pend. Separação */)}</span>
              <div className="bar-container">
                <div
                  className="bar"
                  style={{
                    width: `${info.percSep}%`,
                    backgroundColor: '#FFA500',
                  }}
                />
                <span className="pending-count">{info.pendSep}</span>
              </div>
            </div>
            <div key={`conf-${index}`} className="status-bar">
              <span className="status-label">{I18n.t('BEE4183' /* Pend. Conferência */)}</span>
              <div className="bar-container">
                <div
                  className="bar"
                  style={{
                    width: `${info.percConf}%`,
                    backgroundColor: '#008000',
                  }}
                />
                <span className="pending-count">{info.pendConf}</span>
              </div>
            </div>
            <div key={`bil-${index}`} className="status-bar">
              <span className="status-label">{I18n.t('BEE4184' /* Pend. Faturamento */)}</span>
              <div className="bar-container">
                <div
                  className="bar"
                  style={{
                    width: `${info.percBill}%`,
                    backgroundColor: '#0000FF',
                  }}
                />
                <span className="pending-count">{info.pendBill}</span>
              </div>
            </div>
            <div key={`dock-${index}`} className="status-bar">
              <span className="status-label">{I18n.t('BEE4185' /* Pend. Docas */)}</span>
              <div className="bar-container">
                <div
                  className="bar"
                  style={{
                    width: `${info.percDock}%`,
                    backgroundColor: '#FFFF00',
                  }}
                />
                <span className="pending-count">{info.pendDock}</span>
              </div>
            </div>
            <TruckLoadChartCanvas
              finishedQty={info.done}
              pendingQty={info.pending}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default DynamicCards;
